module.exports = __webpack_public_path__ + "media/images/samples/300x300/6-9f9b4cca900ac2e3696e58f01d9b5bad.jpg";